import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { Select } from "src/app/interface/select/select";
import { CustomSelect } from "../custom/custom-select/custom.select";

@Component({
    selector: 'day-select',
    templateUrl: './day.select.html',
    styleUrls: ['./day.select.scss']
  })
export class DaySelect extends CustomSelect
{
    @Output( ) change: EventEmitter<any> = new EventEmitter<any>()

    values = [
        {
            id : 0,
            name : "select.day.monday"
        },
        {
            id : 1,
            name : "select.day.tuesday"
        }, 
        {
            id : 2,
            name : "select.day.wednesday"
        }, 
        {
            id : 3,
            name : "select.day.thursday"
        }, 
        {
            id : 4,
            name : "select.day.friday"
        }, 
        {
            id : 5,
            name : "select.day.saturday"
        }, 
        {
            id : 6,
            name : "select.day.sunday"
        }, 
    
    ];

    

}